import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import {
    PARAM,
    BLOB_RESPONSE_TYPE,
    AUDIO_HEADERS,
    URL as URL_VALUES,
    RESCORING_OPERATIONS,
    ALL_BOOKS_TRO_HEADERS,
} from '../../../constants/reading/ApiConstants';

const { TRO_RESULTS, TRO_BOOKS } = URL_VALUES.TRO;

class TROClient {
    static getResults = (studentIds, additionalApiParams = {}) => {
        const urlWithQueryParams = constructUrlObject(TRO_RESULTS, {
            [PARAM.STUDENT_IDS]: studentIds.join(),
            ...additionalApiParams,
        });
        return request.get(urlWithQueryParams);
    };

    static getBookData = bookId => request.get(`${TRO_BOOKS}/${bookId}`);

    static getAudioData = (resultId, bookId) =>
        request
            .get(`${TRO_RESULTS}/${resultId}/${bookId}/student_voice_recording`, {
                responseType: BLOB_RESPONSE_TYPE,
                headers: AUDIO_HEADERS,
            })
            .then(response => URL.createObjectURL(response));

    static updateTroContentRemarks = (resultId, userId, data, instUid) =>
        request.patch(`${TRO_RESULTS}/${resultId}`, {
            data,
            [PARAM.STAFF_UID]: userId,
            [PARAM.OPERATION]: RESCORING_OPERATIONS.RESCORE,
            [PARAM.INST_UID]: instUid,
        });

    static revertTroContentRemarks = (resultId, userId, bookId, instUid) =>
        request.patch(`${TRO_RESULTS}/${resultId}`, {
            data: { [PARAM.BOOK_ID]: bookId },
            [PARAM.STAFF_UID]: userId,
            [PARAM.OPERATION]: RESCORING_OPERATIONS.REVERT,
            [PARAM.INST_UID]: instUid,
        });

    static getTroResultById = (resultId, instUid) => {
        const urlWithQueryParams = constructUrlObject(`${TRO_RESULTS}/${resultId}`, {
            [PARAM.INST_UID]: instUid,
        });
        return request.get(urlWithQueryParams);
    };

    static getAllTroBooksData = () =>
        request.get(TRO_BOOKS, {
            headers: ALL_BOOKS_TRO_HEADERS,
        });
}

export default TROClient;
